module.exports = __webpack_public_path__ + "img/ez-slot-ic_deposit_mobile.d5455941.png";